// extracted by mini-css-extract-plugin
module.exports = {"backToExplorer":"BackToExplorer_backToExplorer__n8Z1l","mobile":"BackToExplorer_mobile__t5okh"};